module.exports = __webpack_public_path__ + "img/octagon.99886c78.svg";